import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CheckBoxs = (props) => {
  const { propArr, selectAllTxt, checkBxsChecked, setCheckBxsChecked } = props;
  const [checkbx] = useState([...propArr]);
  const {t} = useTranslation();
  useEffect(() => {
    $('.SrcDect').css('display', 'none');
    document.querySelectorAll('.propsContainers input:checked').forEach((item) => {
      if (item && item.closest('label') && item.closest('label').querySelector('.cbText'))
        item.closest('label').querySelector('.cbText').classList.add('cbTextColor');
    });
  }, []);

  const handleCheckAllBox = (e) => {
    if (e.target.checked) {
      const allCheckbx = checkbx.map((c) => c.id);
      setCheckBxsChecked(allCheckbx);
      e.target.closest('.sepratecheckbox').querySelectorAll('.cbText').forEach(ele => {
        ele.classList.add('cbTextColor');
      });
    } else {
      setCheckBxsChecked([]);
      e.target.closest('.sepratecheckbox').querySelectorAll('.cbText').forEach(ele => {
        ele.classList.remove('cbTextColor');
      });
    }
  };

  const handleCheckBxChange = (e, c) => {
    if (e.target.checked) {
      setCheckBxsChecked([...checkBxsChecked, c.id]);
      e.target.closest('label').querySelector('.cbText').classList.add('cbTextColor');
      setTimeout(() => {
        if (e.target.closest('.sepratecheckbox').querySelectorAll('input')[0].checked) {
          e.target.closest('.sepratecheckbox').querySelectorAll('.cbText')[0].classList.add('cbTextColor');
        }
      });
    } else {
      setCheckBxsChecked(checkBxsChecked.filter((item) => item !== c.id));
      e.target.closest('label').querySelector('.cbText').classList.remove('cbTextColor');
      e.target.closest('.sepratecheckbox').querySelectorAll('.cbText')[0].classList.remove('cbTextColor');
    }
  };

  return (
    <>
      <div className={selectAllTxt} id='trasulationHeader'>
        <FormControlLabel control={
          <Checkbox
            checked={checkBxsChecked.length === checkbx.length}
            onChange={handleCheckAllBox}
            sx={{
              color: '#b8b8cb', // #6C6C6C  border
              '&.Mui-checked': {
                color: '#002D62', // #00AEC7  fill
              },
            }}
          />
        } label={<span className='cbText sallHead'>{selectAllTxt}</span>} />
      </div>

      {checkbx.map((c) => (
        <div className='cbs' key={c.id} id='trasulationHeaderSub'>
          <FormControlLabel control={
            <Checkbox
              checked={checkBxsChecked.includes(c.id)}
              onChange={(e) => handleCheckBxChange(e, c)}
              sx={{
                color: '#b8b8cb', // #6C6C6C  border
                '&.Mui-checked': {
                  color: '#002D62', // #00AEC7  fill
                },
              }}
            />
          } label={<span className='cbText'>{t(c.propName)}</span>} />
        </div>
      ))}
    </>
  );
};
export default CheckBoxs;
// export {checkBxsChecked};